module.exports = __webpack_public_path__ + "static/Madhavi_Nagouda-8d4d0b027272e5f09b25aeefe80d8888.jpg";